import React from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";

const ConfirmationModal = ({ isOpen, toggle, onConfirm }) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Confirm Deletion</ModalHeader>
      <ModalBody>
        Are you sure you want to delete this tracking entry? This action cannot
        be undone.
      </ModalBody>
      <ModalFooter>
        <Button className="bg-white border-primary text-black" onClick={toggle}>
          Cancel
        </Button>
        <Button color="danger" onClick={onConfirm}>
          Yes, Delete
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ConfirmationModal;
